import React from 'react';
import '../home/home.css';

const Detalle = () => {
  return (
    <div className="home-wrap">
      <section className="lead-card">
        <div className="lead-card__header">
          <i className="bi bi-file-earmark-text"></i>
          <h2 className="lead-card__title">Detalles</h2>
        </div>
        <div className="lead-card__body" style={{ textAlign: 'center', padding: '60px 22px' }}>
          <i className="bi bi-cone-striped" style={{ fontSize: 52, color: '#214EB6' }}></i>
          <h3 style={{ marginTop: 16, marginBottom: 6, color: '#33475b', fontWeight: 600 }}>
            Sección en construcción
          </h3>
          <p style={{ color: '#8a99a8', margin: 0 }}>
            Pronto encontrarás aquí el detalle de las asignaciones.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Detalle;
